
import { formatByCountry, resolveCountry } from "@/app/infrastructures/misc/Utils";
import PreviewImagePod from "../../shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";
import {
  DetailDepositRiwayat,
  PhotosDetailSetorRiwayat
} from "@/domain/entities/CodReconcile";
import { computed, defineComponent, PropType, ref } from "vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import moment from "moment";
import { configDates } from "@/app/infrastructures/misc/common-library/modules/Date";

export default defineComponent({
  name: "PopupDepositDetail",
  props: {
    modelValue: { type: Boolean, required: true },
    typeDeposit: { type: String, default: "uang" },
    data: {
      type: Object as PropType<DetailDepositRiwayat>,
      default: () => new DetailDepositRiwayat()
    }
  },
  emits: ["update:modelValue", "see-proof"],
  components: { PreviewImagePod },
  setup(props, { emit }) {
    const visible = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v)
    });

    const isPreviewPhotos = ref(false);

    const onPreview = () => {
      visible.value = false;
      isPreviewPhotos.value = true;
    };

    const onClosePreview = () => {
      isPreviewPhotos.value = false;
      visible.value = true;
    };

    const formattedDate = computed(() => {
      if (!props.data.createdAt) return "-";

      const timezone =
        AccountController.accountData.account_type_detail.partnerLocation?.city
          ?.timezone;
      const utcOffset = timezone.replace("GMT+", "+0").replace(":", "");
      const tzName = configDates(timezone)["id"];

      const formatDate = moment(props.data.createdAt)
        .utcOffset(utcOffset)
        .format("DD MMM YYYY, HH.mm");

      return `${formatDate} ${tzName}`;
    });

    const isMoneyDeposit = computed(() => props.typeDeposit === "uang");

    const prefixCurrency = computed(() =>
      resolveCountry() === "MY" ? "RM" : "Rp"
    );

    return {
      visible,
      isPreviewPhotos,
      formattedDate,
      previewPhotos: computed(() =>
        props.data.photos.map((p: PhotosDetailSetorRiwayat) => p.url)
      ),
      isMoneyDeposit,
      formatByCountry,
      onPreview,
      onClosePreview,
      prefixCurrency
    };
  }
});
